// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7ba4f1b1","726":"f458fb75","952":"2c45de4c"}[chunkId] + ".chunk.js";
};